import { render } from "./Product-Video.vue?vue&type=template&id=65a66e70&scoped=true"
import script from "./Product-Video.vue?vue&type=script&lang=js"
export * from "./Product-Video.vue?vue&type=script&lang=js"

import "./Product-Video.vue?vue&type=style&index=0&id=65a66e70&scoped=true&lang=css"
import "./Product-Video.vue?vue&type=style&index=1&id=65a66e70&lang=css"
script.render = render
script.__scopeId = "data-v-65a66e70"

export default script